import { useId } from 'react';
import { SequenceAttribute } from './SequenceAttribute';
import { JogRangeControl } from '../components/JogRangeControl';
import type { CinematicEditing } from './use-cinematic-waypoints';

export function StudioMapZoom({ editing }: { editing: CinematicEditing }) {
  const value = editing.settings.cameraZoom;
  const helpId = useId();
  return <SequenceAttribute editing={editing} name="cameraZoom" label="map zoom">
    <label className="studio-select-row studio-map-zoom-mode">Map zoom<select aria-label="Map zoom mode" aria-describedby={helpId} value={value == null ? 'auto' : 'manual'} disabled={editing.readOnly}
      onChange={event => editing.set('cameraZoom', event.target.value === 'auto' ? null : 12)}><option value="auto">Auto</option><option value="manual">Manual</option></select></label>
    {value != null && <JogRangeControl label="Zoom" value={value} min={2} max={20} step={.1} disabled={editing.readOnly} onChange={zoom => editing.set('cameraZoom', zoom)} />}
    <p id={helpId} className="studio-map-zoom-help">{value == null
      ? 'Auto uses the camera’s framing. Choose Manual to set how much of the map is visible.'
      : 'Higher values zoom in and show less of the map. Lower values zoom out and show more.'}</p>
  </SequenceAttribute>;
}
